import { useQuery } from '@tanstack/react-query'

import { getLatestNote } from '../../api/notes'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetLatestPartnerNote(memberId?: string) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_PARTNER_LATEST_NOTE, memberId],
      queryFn: () => getLatestNote({ memberId: memberId! }),
      enabled: !!memberId,
   })
}

export { useGetLatestPartnerNote }
export default useGetLatestPartnerNote
